<template>
  <!--  专题首页-->
  <div class="poor">
    <div class="poor_box">
      <el-card>
        <el-form :inline="true" label-width="120px" size="small">
          <el-row>
            <el-col :span="8">
              <el-form-item label="帮扶维度">
                <el-select
                  placeholder="请选择"
                  v-model="searchData.aidType"
                  clearable
                >
                  <el-option
                    v-for="item in aidTypeData"
                    :key="item.enumeration"
                    :label="item.name"
                    :value="item.enumeration"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="扶贫协作和对口支援(天津)">
                <el-select
                  placeholder="请选择"
                  v-model="searchData.aidArea"
                  clearable
                >
                  <el-option
                    v-for="item in aidAreaData"
                    :key="item.enumeration"
                    :label="item.name"
                    :value="item.enumeration"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="扶贫协作和对口支援(西部区)">
                <el-select
                  placeholder="请选择"
                  v-model="searchData.xibuquyu"
                  clearable
                >
                  <el-option
                    v-for="item in xibuList"
                    :key="item.enumeration"
                    :label="item.name"
                    :value="item.enumeration"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="审核状态">
                <el-select
                  clearable
                  placeholder="请选择"
                  size="small"
                  v-model="searchData.examineStatus"
                >
                  <el-option
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                    v-for="item in newsStatus"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12" style="margin: 10px 0 0 10px">
              <a-checkbox @change="zhanGuan" :checked="checkBoxVal1">
                消费扶贫
              </a-checkbox>
              <a-checkbox
                @change="shiXian"
                style="margin-left: 20px"
                :checked="checkBoxVal2"
              >
                美好视线
              </a-checkbox>
              <a-checkbox
                @change="anLi"
                style="margin: 0 20px"
                :checked="checkBoxVal3"
              >
                经典案例
              </a-checkbox>
              <a-checkbox @change="yaoWen" :checked="checkBoxVal4">
                扶贫要闻
              </a-checkbox>
            </el-col>
          </el-row>
          <el-form-item>
            <el-button
              style="margin-left: 120px"
              type="primary"
              @click="poorSearch"
              v-if="menuPerm('aid:query')"
              >查询</el-button
            >

            <el-button
              style="margin-left: 20px"
              type="primary"
              @click="poorAdd"
              v-if="menuPerm('aid:add')"
              >添加</el-button
            >
            <el-button
              style="margin-left: 20px"
              type="primary"
              @click="topicClear"
              >清空</el-button
            >
          </el-form-item>
        </el-form>
      </el-card>

      <el-card>
        <el-table
          :data="poorList"
          :header-cell-style="getRowClass"
          border
          ref="multipleTable"
          style="width: 100%; flex: auto"
          tooltip-effect="light"
          @selection-change="handleSelectionChange"
        >
          <el-table-column
            prop="newsTitle"
            label="新闻标题"
            align="center"
            width="200"
          >
            <template slot-scope="{ row }">
              <a-tooltip>
                <template slot="title">{{ row.newsTitle }}</template>
                <span class="news_title">{{ row.newsTitle }}</span>
              </a-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            prop="aidDate"
            label="历程"
            align="center"
            width="150px"
          ></el-table-column>
          <el-table-column prop="aidType" label="帮扶维度" align="center">
            <template slot-scope="{ row }">
              <div v-for="(item, index) in aidTypeData" :key="index">
                <span v-if="row.aidType == item.enumeration">{{
                  item.name
                }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="aidArea"
            label="扶贫协作和对口支援"
            align="center"
          >
            <template slot-scope="{ row }">
              <div class="xibuquyu">
                <div v-for="(item, index) in aidAreaData" :key="index">
                  <span
                    style="margin: 10px"
                    v-for="(i, ind) in row.aidAreaList"
                    :key="ind"
                    v-if="i == item.enumeration"
                  >
                    {{ item.name }}
                  </span>
                </div>
              </div>

              <hr />
              <div class="xibuquyu">
                <div v-for="i in xibuList" :key="i.index">
                  <span
                    style="margin: 10px"
                    v-for="(n, ind) in row.aidAreaGansuList"
                    :key="ind"
                    v-if="n == i.enumeration"
                  >
                    {{ i.name }}
                  </span>
                </div>
              </div>
            </template>
          </el-table-column>
          <!-- <el-table-column
            prop="isFocusNews"
            label="是否扶贫要闻"
            align="center"
            width="120px"
          >
            <template slot-scope="{ row }">
              <span v-if="row.isFocusNews == 1">是</span>
              <span v-else-if="row.isFocusNews == 0">否</span>
            </template>
          </el-table-column> -->

          <!-- <el-table-column
            prop="examineStatus"
            label="审核状态"
            align="center"
            width="200px"
          >
            <template slot-scope="{ row }">
              <div v-if="menuPerm('aid:submit_review')">
                <span v-if="row.examineStatus == 2">未提交审核</span>
                <span v-if="row.examineStatus == 3">审核中</span>
                <span v-if="row.examineStatus == 4">审核未通过</span>
                <span v-if="row.examineStatus == 1">审核通过</span>
              </div>

              <el-select
                placeholder="请选择"
                v-model="row.examineStatus"
                v-if="menuPerm('aid:review')"
                @change="examChange($event, row)"
              >
                <el-option
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                  v-for="item in revernewsStatus"
                ></el-option>
              </el-select>
            </template>
          </el-table-column> -->
          <el-table-column
            prop="isPovertyNews"
            label=""
            align="center"
            width="200px"
          >
            <template slot-scope="{ row }">
              <p style="display: flex; margin-top: 24px">
                <el-button
                  size="mini"
                  type="info"
                  v-if="row.isPovertyNews == '0' || row.isPovertyNews == ''"
                  style="margin: 0 0 10px 10px"
                  >消费扶贫</el-button
                >
                <el-button
                  size="mini"
                  type="success"
                  v-if="row.isPovertyNews == '1'"
                  style="margin: 0 0 10px 10px"
                  >消费扶贫</el-button
                >
                <el-button
                  size="mini"
                  type="info"
                  v-if="row.isFineNews == '0' || row.isFineNews == ''"
                  style="margin: 0 0 10px 10px"
                  >美好视线</el-button
                >
                <el-button
                  size="mini"
                  type="success"
                  v-if="row.isFineNews == '1'"
                  style="margin: 0 0 10px 10px"
                  >美好视线</el-button
                >
              </p>
              <p style="display: flex">
                <el-button
                  size="mini"
                  type="info"
                  v-if="row.isClassicNews == '0' || row.isClassicNews == ''"
                  style="margin: 0 0 10px 10px"
                  >经典案例</el-button
                >
                <el-button
                  size="mini"
                  type="success"
                  v-if="row.isClassicNews == '1'"
                  style="margin: 0 0 10px 10px"
                  >经典案例</el-button
                >
                <el-button
                  size="mini"
                  type="info"
                  v-if="row.isFocusNews == '0' || row.isFocusNews == ''"
                  style="margin: 0 0 10px 10px"
                  >扶贫要闻</el-button
                >
                <el-button
                  size="mini"
                  type="success"
                  v-if="row.isFocusNews == '1'"
                  style="margin: 0 0 10px 10px"
                  >扶贫要闻</el-button
                >
              </p>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            class-name="small-padding fixed-width"
            label="操作"
            width="180px"
            fixed="right"
          >
            <template slot-scope="{ row }">
              <div class="done">
                <!-- 2->未提交审核；4->审核未通过（可点击） -->
                <el-button
                  size="mini"
                  type="primary"
                  @click="getpoorEdit(row)"
                  :disabled="
                    (row.examineStatus == 1 || row.examineStatus == 3) &&
                    allOpen
                      ? true
                      : false
                  "
                  v-if="menuPerm('aid:edit')"
                  >修改</el-button
                >

                <!-- <el-button
                  size="mini"
                  type="primary"
                  @click="getpoorEdit(row)"
                  v-if="!reviewerUser"
                >修改</el-button>-->

                <!-- 审核中、通过--发布者--不能删除 -->

                <el-button
                  size="mini"
                  type="primary"
                  @click="poorDel(row.id)"
                  :disabled="
                    (row.examineStatus == 1 || row.examineStatus == 3) &&
                    allOpen
                      ? true
                      : false
                  "
                  v-if="menuPerm('aid:delete')"
                  >删除</el-button
                >

                <!-- 2->未提交审核；4->审核未通过 -->
                <el-button
                  @click="handleExamine(row)"
                  size="mini"
                  type="primary"
                  v-if="menuPerm('aid:submit_review')"
                  :disabled="
                    (row.examineStatus == 1 || row.examineStatus == 3) &&
                    allOpen
                      ? true
                      : false
                  "
                  >提交审核</el-button
                >
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-row style="width: auto; marginright: 50px; margintop: 20px">
          <el-pagination
            :current-page="currentPage"
            :page-size="pagesize"
            :page-sizes="[5, 10, 15]"
            :total="totalCount"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          ></el-pagination>
        </el-row>
      </el-card>
    </div>

    <!-- 删除弹框 -->
    <a-modal
      title
      :visible="delOpen"
      @ok="delOk"
      ok-text="确认"
      cancel-text="取消"
      @cancel="delCancel"
    >
      <p>确认删除吗？</p>
    </a-modal>
    <!-- 修改弹出框 -->
    <a-modal
      title
      :visible="editOpen"
      @ok="editOk"
      ok-text="确认"
      cancel-text="取消"
      @cancel="editCancel"
    >
      <el-form :inline="true" size="small">
        <el-row>
          <el-col :span="12">
            <el-form-item label="帮扶维度">
              <el-select
                placeholder="请选择"
                v-model="editData.aidType"
                clearable
              >
                <el-option
                  v-for="item in aidTypeData"
                  :key="item.enumeration"
                  :label="item.name"
                  :value="item.enumeration"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="历程">
              <el-date-picker
                v-model="editData.aidDate"
                type="date"
                placeholder="选择日期"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="扶贫协作和对口支援(天津)" prop="aidAreaList">
              <el-select
                v-model="editData.aidAreaList"
                multiple
                placeholder="请选择"
              >
                <el-option
                  v-for="item in aidAreaData"
                  :key="item.enumeration"
                  :label="item.name"
                  :value="item.enumeration"
                >
                </el-option>
              </el-select>
              <!-- <el-select
                placeholder="请选择"
                v-model="editData.aidArea"
                clearable
              >
                <el-option
                  v-for="item in aidAreaData"
                  :key="item.enumeration"
                  :label="item.name"
                  :value="item.enumeration"
                ></el-option>
              </el-select> -->
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="扶贫协作和对口支援(西部区)">
              <el-select
                v-model="editData.aidAreaGansuList"
                multiple
                placeholder="请选择"
              >
                <el-option
                  v-for="item in xibuList"
                  :key="item.enumeration"
                  :label="item.name"
                  :value="item.enumeration"
                >
                </el-option>
              </el-select>
              <!-- <el-select
                placeholder="请选择"
                v-model="editData.aidAreaGansuList"
                clearable
              >
                <el-option
                  v-for="item in xibuList"
                  :key="item.enumeration"
                  :label="item.name"
                  :value="item.enumeration"
                ></el-option>
              </el-select> -->
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-checkbox
            :false-label="0"
            :true-label="1"
            v-model="editData.isPovertyNews"
            >消费扶贫</el-checkbox
          >
          <el-checkbox
            :false-label="0"
            :true-label="1"
            v-model="editData.isFineNews"
            >美好视线</el-checkbox
          >
          <el-checkbox
            :false-label="0"
            :true-label="1"
            v-model="editData.isClassicNews"
            >经典案例</el-checkbox
          >
          <el-checkbox
            :false-label="0"
            :true-label="1"
            v-model="editData.isFocusNews"
            >扶贫要闻</el-checkbox
          >

          <!-- <a-checkbox @change="yaoWenChange" :value="editData.isFocusNews"> 扶贫要闻 </a-checkbox> -->
          <!-- <a-checkbox @change="anLiChange" style="margin-left: 20px">
            经典案例
          </a-checkbox>
          <a-checkbox @change="shiXianChange" style="margin: 0 20px">
            美好视线
          </a-checkbox>
          <a-checkbox @change="zhanGuanChange"> 消费扶贫 </a-checkbox> -->
          <!-- <el-col :span="12">
            <el-form-item label="是否扶贫要闻">
              <el-select
                placeholder="请选择"
                v-model="editData.isFocusNews"
                clearable
              >
                <el-option
                  v-for="item in FocusNewsData"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col> -->
        </el-row>
      </el-form>
    </a-modal>
  </div>
</template>
<script>
export default {
  data() {
    return {
      checkBoxVal1: false, //扶贫展
      checkBoxVal2: false, //美好视线清空checkbox
      checkBoxVal3: false, //经典案例清空checkbox
      checkBoxVal4: false, //扶贫要闻清空
      allOpen: true, //没有限制
      //角色：

      poorList: [], //扶贫列表
      pagesize: 10, //每页的个数
      currentPage: 1, //初始页
      totalCount: 0, //分页数量展示

      //查询的数据：
      searchData: {
        aidType: "", //帮扶维度
        aidArea: "", //扶贫协作和对口支援
        modelPower: "", //典范力量
        examineStatus: "", //审核状态
        isFocusNews: "", //是否扶贫要闻
        xibuquyu: "", //扶贫协作和对口支援(西部区域)
        isFineNews: "", //是否美好视线
        isClassicNews: "", //是否经典案例
        isPovertyNews: "", //是否消费扶贫
      },

      editData: "", //修改的数据
      delId: "", //删除id
      delOpen: false, //删除弹框
      editOpen: false, //修改弹框

      //   下拉框的数据：
      aidTypeData: "", //帮扶维度下拉框数据
      aidAreaData: "", //扶贫协作和对口支援下拉框数据
      xibuList: "", //扶贫协作和对口支援(西部区域)
      // modelPowerData: "", //典范力量下拉框数据

      //是否扶贫要闻
      FocusNewsData: [
        {
          value: 1,
          label: "是",
        },
        {
          value: 0,
          label: "否",
        },
      ],

      //状态--下拉框：
      newsStatus: [
        {
          value: "2",
          label: "未提交审核",
        },
        {
          value: "3",
          label: "审核中",
        },
        {
          value: "4",
          label: "审核未通过",
        },
        {
          value: "1",
          label: "审核通过",
        },
      ],
      //状态--下拉框：
      revernewsStatus: [
        {
          value: 1,
          label: "审核通过",
        },
        {
          value: 3,
          label: "审核中",
        },
        {
          value: 4,
          label: "审核未通过",
        },
      ],

      // 审核者（r）--查询审核状态：
      searchExam: [
        {
          value: 1,
          label: "审核通过",
        },
        {
          value: 3,
          label: "审核中",
        },
      ],

      //首页轮播--下拉框：
      homeLun: [
        {
          value: "1",
          label: "是",
        },
        {
          value: "0",
          label: "不是",
        },
      ],
    };
  },
  methods: {
    //修改扶贫的审核状态--审核者
    examChange(val, row) {
      this.getAxios("/aidNews/review", {
        id: row.id,
        examineStatus: val,
      }).then((res) => {
        if (res.success == true) {
          this.$message.success("修改审核状态成功");
          this.getPoor();
        } else if (res.success == false) {
          this.$message.error(res.message);
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        }
      });
    },

    //发布者- 提交审核：
    handleExamine(row) {
      this.getAxios("/aidNews/submit/review", {
        id: row.id,
        // examineStatus:row.examineStatus
      }).then((res) => {
        if (res.success == true) {
          this.$message.success("提交审核成功");
          this.getPoor();
        } else if (res.success == false) {
          this.$message.error(res.message);
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        }
      });
    },
    //头部样式
    getRowClass({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color: #f5f7fa;color:#000;width:100%;text-aligin:center;text-align: center;";
      } else {
        return "";
      }
    },
    //扶贫列表：
    getPoor() {
      this.postAxios("/aidNews/list", {
        pageNum: this.currentPage,
        pageSize: 10,
        aidType: this.searchData.aidType, //帮扶维度
        aidArea: this.searchData.aidArea, //扶贫协作和对口支援
        modelPower: this.searchData.modelPower, //典范力量
        examineStatus: this.searchData.examineStatus, //审核状态
        isFocusNews: this.searchData.isFocusNews, // 是否扶贫要闻
      }).then((res) => {
        if (res.success == true) {
          this.poorList = res.content;
          this.totalCount = res.totalCount;
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        } else if (res.success == false) {
          this.$message.error(res.message);
        }
      });
    },

    //扶贫查询：
    poorSearch() {
      this.currentPage = 1;
      this.postAxios("/aidNews/list", {
        pageNum: this.currentPage,
        pageSize: 10,
        aidType: this.searchData.aidType, //帮扶维度
        aidArea: this.searchData.aidArea, //扶贫协作和对口支援
        modelPower: this.searchData.modelPower, //典范力量
        examineStatus: this.searchData.examineStatus, //审核状态
        isFocusNews: this.searchData.isFocusNews, // 是否扶贫要闻
        isFineNews: this.searchData.isFineNews, //是否美好视线
        isClassicNews: this.searchData.isClassicNews, //是否经典案例
        isPovertyNews: this.searchData.isPovertyNews, //是否消费扶贫
        aidAreaGansu: this.searchData.xibuquyu, //西部区域
      }).then((res) => {
        if (res.success == true) {
          this.poorList = res.content;
          this.totalCount = res.totalCount;
        } else if (res.success == false) {
          this.$message.error(res.message);
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        }
      });
    },
    //清空查询条件：
    topicClear() {
      this.searchData = [];
      this.checkBoxVal1 = false;
      this.checkBoxVal2 = false;
      this.checkBoxVal3 = false;
      this.checkBoxVal4 = false;
      // this.searchData.isFocusNews="";
      // this.searchData.isFineNews="";
      // this.searchData.isClassicNews="";
      // this.searchData.isPovertyNew=""
    },
    //新增专题：
    poorAdd() {
      this.$router.push({ path: "/poorDetail" });
    },

    //修改取消弹框
    editCancel() {
      this.editOpen = false;
    },
    //修改确认弹框
    editOk() {
      var arrT = [];
      this.editData.aidAreaList.map((i) => {
        if (typeof i == "string") {
          this.aidAreaData.map((x) => {
            if (i == x.name) {
              arrT.push(x.enumeration);
            }
          });
        } else {
          arrT.push(i);
        }
      });
      var arrX = [];
      this.editData.aidAreaGansuList.map((i) => {
        if (typeof i == "string") {
          this.xibuList.map((x) => {
            if (i == x.name) {
              arrX.push(x.enumeration);
            }
          });
        } else {
          arrX.push(i);
        }
      });
      this.postAxios("/aidNews/update", {
        id: this.editData.id, //扶贫id
        newsId: this.editData.newsId, //新闻 id
        aidDate: this.formatDateTime(this.editData.aidDate), //扶贫时间
        aidType: this.editData.aidType, //帮扶维度
        aidAreaList: arrT, //扶贫协作和对口支援
        // modelPower: this.editData.modelPower, //典范力量
        aidAreaGansuList: arrX, //西部区域
        isFocusNews: this.editData.isFocusNews, // 是否扶贫要闻
        isFineNews: this.editData.isFineNews, //美好视线
        isClassicNews: this.editData.isClassicNews, //经典案例
        isPovertyNews: this.editData.isPovertyNews, //消费扶贫
      }).then((res) => {
        if (res.success == true) {
          this.editOpen = false;
          this.$message.success(res.message);
          this.getPoor(); //获取扶贫列表
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        } else if (res.success == false) {
          this.$message.error(res.message);
        }
      });
    },

    //转时间
    addZero(num) {
      return num < 10 ? "0" + num : num;
    },
    //转时间
    formatDateTime(date) {
      const time = new Date(Date.parse(date));
      // time.setTime(time.setHours(time.getHours() + 8));
      const Y = time.getFullYear() + "-";
      const M = this.addZero(time.getMonth() + 1) + "-";
      const D = this.addZero(time.getDate()) + " ";
      const h = this.addZero(time.getHours()) + ":";
      const m = this.addZero(time.getMinutes()) + ":";
      const s = this.addZero(time.getSeconds());
      // const s = this.addZero(time.getSeconds());
      return Y + M + D + h + m + s;
    },
    //扶贫修改弹框出现：
    getpoorEdit(obj) {
      if (this.editData != "") {
        var arrXibu = []; //西部
        var arrTianjin = []; //西部
        // 西部区域
        this.editData.aidAreaGansuList.map((i) => {
          this.xibuList.map((x) => {
            if (i == x.enumeration) {
              arrXibu.push(x.enumeration);
            }
          });
        });
        this.editData.aidAreaGansuList = arrXibu;
        // 天津区域
        this.editData.aidAreaList.map((i) => {
          this.aidAreaData.map((x) => {
            if (i == x.enumeration) {
              arrTianjin.push(x.enumeration);
            }
          });
        });
        this.editData.aidAreaList = arrTianjin;
      }
      this.editData = obj; //修改数据
      this.editData.aidType = Number(this.editData.aidType); //帮扶维度
      this.editData.aidArea = Number(this.editData.aidArea); //扶贫协作和对口支援
      this.editData.aidAreaGansu = Number(this.editData.aidAreaGansu);
      this.editData.isFocusNews = Number(this.editData.isFocusNews);
      this.editData.isFineNews = Number(this.editData.isFineNews);
      this.editData.isClassicNews = Number(this.editData.isClassicNews);
      this.editData.isPovertyNews = Number(this.editData.isPovertyNews);
      this.editOpen = true;
    },

    //分页
    handleCurrentChange: function (currentPage) {
      this.currentPage = currentPage;
      this.getPoor();
    },
    //分页：
    handleSizeChange: function (size) {
      this.pagesize = size;
      this.getPoor();
    },
    //分页
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 扶贫要闻
    yaoWen(e) {
      var val = e.target.checked;
      if (val == true) {
        this.searchData.isFocusNews = 1;
        this.checkBoxVal4 = true;
      } else {
        this.searchData.isFocusNews = "";
        this.checkBoxVal4 = false;
      }
    },
    // 经典案例
    anLi(e) {
      var val = e.target.checked;
      if (val == true) {
        this.searchData.isClassicNews = 1;
        this.checkBoxVal3 = true;
      } else {
        this.searchData.isClassicNews = "";
        this.checkBoxVal3 = false;
      }
    },
    // 美好视线
    shiXian(e) {
      var val = e.target.checked;
      if (val == true) {
        this.searchData.isFineNews = 1;
        this.checkBoxVal2 = true;
      } else {
        this.searchData.isFineNews = "";
        this.checkBoxVal2 = false;
      }
    },
    // 消费扶贫
    zhanGuan(e) {
      var val = e.target.checked;
      if (val == true) {
        this.searchData.isPovertyNews = 1;
        this.checkBoxVal1 = true;
      } else {
        this.searchData.isPovertyNews = "";
        this.checkBoxVal1 = false;
      }
    },
    // 扶贫删除：
    poorDel(id) {
      this.delId = id; //删除id
      this.delOpen = true;
    },

    //删除确认框：
    delOk() {
      this.getAxios("/aidNews/delete", {
        id: this.delId,
      }).then((res) => {
        if (res.success == true) {
          this.delOpen = false;
          this.$message.success("删除扶贫成功");
          this.getPoor();
        } else if (res.success == false) {
          this.$message.error(res.message);
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        }
      });
    },

    //删除取消框：
    delCancel() {
      this.delOpen = false;
    },

    // 帮扶维度下拉框
    getaidType() {
      this.getAxios(`/dic/list/aidType`, {}).then((res) => {
        if (res.success == true) {
          this.aidTypeData = res.content;
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        } else if (res.success == false) {
          this.$message.error(res.message);
        }
      });
    },
    //扶贫协作和对口支援下拉框
    getaidArea() {
      this.getAxios(`/dic/list/aidArea`, {}).then((res) => {
        if (res.success == true) {
          this.aidAreaData = res.content;
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        } else if (res.success == false) {
          this.$message.error(res.message);
        }
      });
    },
    //西部区域下拉框
    getxibuArea() {
      this.getAxios("/dic/list/xibuquxian").then((res) => {
        if (res.success == true) {
          this.xibuList = res.content;
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        } else if (res.success == false) {
          this.$message.error(res.message);
        }
      });
    },
  },
  created() {
    this.getPoor(); //获取扶贫列表
    this.getaidType(); //帮扶维度下拉框
    this.getaidArea(); //扶贫协作和对口支援下拉框
    this.getxibuArea(); //西部区域下拉框

    if (this.menuPerm("aid:edit_super") == true) {
      this.allOpen = false;
    }
  },
  mounted() {},
  watch: {
    editData(newVal, oldVal) {
      this.editData = newVal;
      this.getpoorEdit(newVal);
    },
  },
};
</script>
<style scoped lang="less">
.poor {
  width: 100%;
  height: 100%;
  .poor_box {
    width: 95%;
    height: auto;
    margin: 20px auto;
    .el-card {
      margin-top: 15px;
      .news_title {
        display: block;
        width: 170px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
    .done {
      display: flex;
      flex-direction: column;
      width: 100px;
      position: relative;
      top: -10px;

      /deep/ .el-button--primary {
        color: #fff;
        background-color: #409eff;
        border-color: #409eff;
        width: 100px;
        margin-top: 10px;
        margin-left: 10px;
      }
    }
    /deep/ .el-button--primary {
      color: #fff;
      background-color: #409eff;
      border-color: #409eff;
      width: 100px;
    }
  }
}
.xibuquyu {
  display: flex;
  flex-wrap: wrap;
}
</style>